
export const TECHNOLOGIES = [
    'led',
    'sodio',
    'mercurio',
    'metal halide'
];
const TYPE = [
  {
    id: 'H',
    description: 'Horizontal'
  },
  {
    id: 'V',
    description: 'Vertical'
  },
  {
    id: 'A',
    description: 'Abierta'
  },
  {
    id: 'C',
    description: 'Cerrada'
  },
  {
    id: 'HA',
    description: 'Horizontal Abierta'
  },
  {
    id: 'HC',
    description: 'Horizontal Cerrada'
  },
  {
    id: 'VA',
    description: 'Vertical Abierta'
  },
  {
    id: 'VC',
    description: 'Vertical Cerrada'
  },
];
const SPECIAL = [
  {
    id: 'LUMINARY',
    description: 'Luminaria'
  },
  {
    id: 'FAROL',
    description: 'Farol'
  },
  {
    id: 'REFLECTOR',
    description: 'Reflector'
  },
];

const ANOMALY = [
  {
    id: 'OFF',
    description: 'Apagada'
  },
  {
    id: 'DIRECT',
    description: 'Directa'
  },
];
const SWITCHEDON = [
  {
    id: 'REVEL',
    description: 'Revelador'
  },
  {
    id: 'PHOTO',
    description: 'Fotocelda'
  },
  {
    id: 'MANUAL',
    description: 'Operación manual'
  },
];

const ELECTRIC_NETWORK = [
  {
    id: 'DISTRIBUTION',
    description: 'Distribución'
  },
  {
    id: 'EXCLUSIVE',
    description: 'Exclusiva'
  },
];

const UR = [
  {
    id: 'U',
    description: 'U'
  },
  {
    id: 'R',
    description: 'R'
  },
];

const POST = [
  {
    id: 'PRIMARY',
    description: 'Primario'
  },
  {
    id: 'SECONDARY',
    description: 'Secundario'
  },
  {
    id: 'EXCLUSIVE',
    description: 'Exclusivo'
  },
]

const POST_CLASS = [
  {
    id: 'CONCRETE',
    description: 'Concreto'
  },
  {
    id: 'METALIC',
    description: 'Metálico'
  },
  {
    id: 'FIBER_GLASS',
    description: 'Fibra de vidrio'
  },
  {
    id: 'TOWER',
    description: 'Torrecilla'
  },
];

const RETILAP = [
  {
    id: 'M1',
    description: 'M1'
  },
  {
    id: 'M2',
    description: 'M2'
  },
  {
    id: 'M3',
    description: 'M3'
  },
  {
    id: 'M4',
    description: 'M4'
  },
  {
    id: 'M5',
    description: 'M5'
  },
  {
    id: 'P1',
    description: 'P1'
  },
  {
    id: 'P2',
    description: 'P2'
  },
  {
    id: 'P3',
    description: 'P3'
  },
  {
    id: 'P4',
    description: 'P4'
  },
  {
    id: 'P5',
    description: 'P5'
  },
  {
    id: 'C1',
    description: 'C1'
  },
  {
    id: 'C2',
    description: 'C2'
  },
  {
    id: 'C3',
    description: 'C3'
  },
  {
    id: 'C4',
    description: 'C4'
  },
  {
    id: 'C5',
    description: 'C5'
  },

];

const MAINTENANCE_TYPES = [
  {
    id: 'CORRECTIVE',
    description: 'Mantenimiento Correctivo'
  },
  {
    id: 'PREVENTIVE',
    description: 'Mantenimiento Preventivo'
  },
  {
    id: 'OTHER',
    description: 'Actividades adicionales'
  },
];
const ONLY_CORRECTIVE_PERMISSIONS = ['DRIVER', 'TECHNICIAN'];
const CORRECTIVE = {
  id: 'CORRECTIVE',
  description: 'Mantenimiento Correctivo'
};
const PREVENTIVE = {
  id: 'PREVENTIVE',
  description: 'Mantenimiento Preventivo'
};

const EXPANSION = {
  id: 'EXPANSION',
  description: 'Expansión'
};

const TYPES = [
  CORRECTIVE,
  PREVENTIVE,
  {
    id: 'MODERNIZATION',
    description: 'Modernización'
  },
  EXPANSION,
  {
    id: 'OTHER',
    description: 'Actividades adicionales'
  },
];

const PAIN_TYPES = [
  {
    id: 'NO_POWEROFF',
    description: 'Encendida las 24 horas'
  },
  {
    id: 'INTERMITENT',
    description: 'Presenta apagados intermitentes'
  },
  {
    id: 'OFF',
    description: 'Apagada'
  },
  {
    id: 'DISCONNECTED',
    description: 'Desconectada'
  },
  {
    id: 'NO_LUMINARY',
    description: 'No tiene luminaria'
  },
  {
    id: 'OTHER',
    description: 'Otros'
  }
];

const INSTALLATION_ZONES = [
  {
    id: 'URBAN',
    description: 'Urbana'
  },
  {
    id: 'RURAL',
    description: 'Rural'
  }
];

const SPACE_TYPES = [
  {
    id: 'VEHICULAR',
    description: 'Vía vehicular'
  },
  {
    id: 'PARK',
    description: 'Parque'
  },
  {
    id: 'PATH',
    description: 'Sendero peatonal'
  },
  {
    id: 'SPORT',
    description: 'Escenario deportivo'
  },
];

const ELECTRICAL_NETWORK_MATERIAL_TYPES = [
  {
    id: 'AL',
    description: 'Aluminio'
  },
  {
    id: 'CU',
    description: 'Cobre'
  },
]
export const TYPES_MATERIAL = [
  {
    id: 'INSTALLED',
    description: 'Instalados'
  },
  {
    id: 'RETIRED',
    description: 'Retirados'
  },
];

export const TRANSFORMER_INSTALLATION_TYPES = [
  {
    id: 'AIR',
    description: 'Aéreo'
  },
  {
    id: 'PED',
    description: 'Pedestal'
  },
  {
    id: 'SUB',
    description: 'Subterráneo'
  },
];

export const POWER_NETWORK_INSTALLATION_TYPES = [
  {
    id: 'AIR',
    description: 'Aérea'
  },
  {
    id: 'SUB',
    description: 'Subterránea'
  },
];

export const USE_CANALIZATION_TYPES = [
  {
    id: 'E',
    description: 'Exclusiva'
  },
  {
    id: 'S',
    description: 'Compartida'
  },
];

export const USE_TRANSFOMER_TYPES = [
  {
    id: 'E',
    description: 'Exclusiva'
  },
  {
    id: 'D',
    description: 'Distribución'
  },
];

export const PIPE_TYPES = [
  {
    id: 'PVC',
    description: 'PVC'
  },
  {
    id: 'EMC',
    description: 'EMC'
  },
  {
    id: 'IMC',
    description: 'IMC'
  },
];

export const PIPE_ZONE_TYPES = [
  {
    id: 'GREEN',
    description: 'Zona verde'
  },
  {
    id: 'HARD',
    description: 'Zona dura'
  },
  {
    id: 'VEHICULAR',
    description: 'Zona de cruce vehicular'
  },
];

export const ADD_MATERIAL_ACTIVITY = {
  id: 'ADD_MATERIAL',
  description: 'Instalación de material',
};
export const EXTRACT_MATERIAL_ACTIVITY = {
  id: 'EXTRACT_MATERIAL',
  description: 'Retirada de material',
};
export const CONNECTIONS_ADJUST = {
  id: 'CONNECTIONS_ADJUST',
  description: 'Ajuste de conexiones',
};
export const PHOTOCELL_CHANGE = {
  id: 'PHOTOCELL_CHANGE',
  description: 'Cambio de fotocelda',
};
export const CLEAN_OPTIC = {
  id: 'CLEAN_OPTIC',
  description: 'Limpieza de óptica',
};
export const CLEAN_ELECTRONIC = {
  id: 'CLEAN_OPTIC',
  description: 'Limpieza de elementos electrónicos',
};
export const CONNECTORS_CHANGE = {
  id: 'CONNECTORS_CHANGE',
  description: 'Cambio de conectores',
};
export const BULB_CHANGE = {
  id: 'BULB_CHANGE',
  description: 'Cambio de bombillo',
};
export const ELECTRONIC_COMPONENTS_CHANGE = {
  id: 'ELECTRONIC_COMPONENTS_CHANGE',
  description: 'Cambio de elementos electrónicos',
};
export const ELECTRIC_COMPONENTS_CHANGE = {
  id: 'ELECTRIC_COMPONENTS_CHANGE',
  description: 'Cambio de elementos eléctricos',
};
export const LUMINARY_OPENING_TO_CLEAN = {
  id: 'LUMINARY_OPENING_TO_CLEAN',
  description: 'Apertura para limpieza de luminaria',
};
export const PHOTOCELL_ADJUST = {
  id: 'PHOTOCELL_ADJUST',
  description: 'Ajuste de base de fotocelda',
};
export const RUSH_CHANGE = {
  id: 'RUSH_CHANGE',
  description: 'Cambio de acometida',
};
export const GROUNDING_INSTALL = {
  id: 'GROUNDING_INSTALL',
  description: 'Instalación de puesta a tierra',
};
export const GROUNDING_ADJUST = {
  id: 'GROUNDING_ADJUST',
  description: 'Ajuste de puesta a tierra',
};

export const COLLAR_ADJUSTMENT = {
  id: "COLLAR_ADJUSTMENT",
  description: "Ajute de collarines"
};

export const BRANCH_CLEARING = {
  id: "BRANCH_CLEARING",
  description: "Despeje de ramas "
};

export const LUMINAIRE_RELOCATION = {
  id: "LUMINAIRE_RELOCATION",
  description: "Reubicación de luminaria"
};
const LUMINAIRE_REORIENTATION = {
  id: "LUMINAIRE_REORIENTATION",
  description: "Reorientación de luminaria"
};

const LUMINAIRE_CHANGE = {
    id: "LUMINAIRE_CHANGE",
    description: "Cambio de luminaria"
  };

// medida de voltaje
const VOLTAGE_MEASURE = {
    id: "VOLTAGE_MEASURE",
    description: "Medida de voltaje"
};

// medida de parámetros eléctricos de luminaria y sus componentes
const LUMINARY_COMPONENT_MEASURE = {
    id: "LUMINARY_COMPONENT_MEASURE",
    description: "Medida de parámetros eléctricos"
};

// medida fotométrica a la calzada
const PHOTOMETRIC_MEASURE = {
    id: "PHOTOMETRIC_MEASURE",
    description: "Medida forométrica"
};


export const ACTIVITY_TYPES = [
  LUMINAIRE_CHANGE,
  CONNECTIONS_ADJUST,
  PHOTOCELL_CHANGE,
  CLEAN_OPTIC,
  CONNECTORS_CHANGE,
  BULB_CHANGE,
  ELECTRONIC_COMPONENTS_CHANGE,
  ELECTRIC_COMPONENTS_CHANGE,
  LUMINARY_OPENING_TO_CLEAN,
  PHOTOCELL_ADJUST,
  RUSH_CHANGE,
  GROUNDING_INSTALL,
  GROUNDING_ADJUST,
  LUMINAIRE_REORIENTATION,
  COLLAR_ADJUSTMENT,
  BRANCH_CLEARING,
  LUMINAIRE_RELOCATION,
  VOLTAGE_MEASURE,
  LUMINARY_COMPONENT_MEASURE,
  PHOTOMETRIC_MEASURE,
];


export const BURNED_DPS = {
  id: 'BURNED_DPS',
  description: 'DPS quemado'
};

export const BURNED_OR_OUT_OF_RANGE_DRIVER = {
  id: 'BURNED_OR_OUT_OF_RANGE_DRIVER',
  description: 'Driver quemado o fuera de rango'
};

export const BURNED_OR_DIRECT_PHOTOCELL = {
  id: 'BURNED_OR_DIRECT_PHOTOCELL',
  description: 'Fotocelda quemada o directa'
};

export const BURNED_OR_BROKEN_PHOTOCELL_BASE = {
  id: 'BURNED_OR_BROKEN_PHOTOCELL_BASE',
  description: 'Base de fotocelda quemada o partida'
};

export const BAD_CONNECTIONS = {
  id: 'BAD_CONNECTIONS',
  description: 'Conexiones en mal estado'
};

export const BURNED_CABLES = {
  id: 'BURNED_CABLES',
  description: 'Cables quemados'
};

export const BURNED_CONNECTORS = {
  id: 'BURNED_CONNECTORS',
  description: 'Conectores quemados'
};

export const WATER_LEAKAGE = {
  id: 'WATER_LEAKAGE',
  description: 'Filtración de agua'
};

export const VANDALIZED_LUMINAIRE = {
  id: 'VANDALIZED_LUMINAIRE',
  description: 'Luminaria bandalizada'
};

export const DAMAGED_POWER_SUPPLY = {
  id: 'DAMAGED_POWER_SUPPLY',
  description: 'Acometida en mal estado'
};

export const OTHER = {
  id: 'OTHER',
  description: 'Otros'
};

const ARM_LENGTHS = [1, 1.5, 2, 2.5, 3];
const ANGLES_OF_INCLINATION = [0, 5, 10, 15, 20];


export const ALLEGED_CAUSE_OF_FAIL = [
  BURNED_DPS,
  BURNED_OR_OUT_OF_RANGE_DRIVER,
  BURNED_OR_DIRECT_PHOTOCELL,
  BURNED_OR_BROKEN_PHOTOCELL_BASE,
  BAD_CONNECTIONS,
  BURNED_CABLES,
  BURNED_CONNECTORS,
  WATER_LEAKAGE,
  VANDALIZED_LUMINAIRE,
  DAMAGED_POWER_SUPPLY,
  OTHER
];

export default {
  ARM_LENGTHS,
  ANGLES_OF_INCLINATION,
  POWER_NETWORK_INSTALLATION_TYPES,
  ELECTRICAL_NETWORK_MATERIAL_TYPES,
  TRANSFORMER_INSTALLATION_TYPES,
  USE_CANALIZATION_TYPES,
  USE_TRANSFOMER_TYPES,
  PIPE_TYPES,
  PIPE_ZONE_TYPES,
  ONLY_CORRECTIVE_PERMISSIONS,
  CORRECTIVE,
  PREVENTIVE,
  EXPANSION,
  TYPES,
  PAIN_TYPES,
  POST_CLASS,
  POST,
  UR,
  ELECTRIC_NETWORK,
  SWITCHEDON,
  ANOMALY,
  SPECIAL,
  TYPE,
  TECHNOLOGIES,
  RETILAP,
  INSTALLATION_ZONES,
  MAINTENANCE_TYPES,
  SPACE_TYPES
}
